var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHistory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/History",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1, 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_interaction-history",
    fillRule: "nonzero",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41645552,1.79395201e-07 C6.55996206,1.79395201e-07 4.77950611,0.737703315 3.46676702,2.05076104 C2.15402794,3.36381876 1.41653861,5.14470715 1.41653861,7.00165124 L1.41653861,7.01392824 L2.97201516,7.00000018 C2.96594693,5.73459141 3.39968389,4.5046948 4.19919861,3.52187074 C4.99871332,2.53904669 6.11444791,1.86421594 7.35597721,1.61255336 C8.59750652,1.36089078 9.887874,1.5479959 11.0068493,2.14193497 C12.1258246,2.73587405 13.0040475,3.6998309 13.4916302,4.86928595 C13.9792129,6.03874101 14.0459323,7.34120494 13.6804007,8.55438224 C13.3148692,9.76755954 12.5397442,10.8162516 11.4873189,11.5214753 C10.4348936,12.2266991 9.17040225,12.5447407 7.90965925,12.42132 C6.64891626,12.2978994 5.47006949,11.7406661 4.57431439,10.844725 L3.46963728,11.9496707 C4.28347228,12.7637302 5.2854746,13.3644524 6.38687632,13.6986188 C7.48827804,14.0327852 8.65507672,14.0900795 9.78390532,13.8654262 C10.9127339,13.6407729 11.9687436,13.1411074 12.8583815,12.4106952 C13.7480194,11.680283 14.4438221,10.7416726 14.884146,9.67801727 C15.3244698,8.61436197 15.4957224,7.45849794 15.3827323,6.31282397 C15.2697422,5.16715001 14.8759968,4.06703496 14.2363798,3.10993871 C13.5967628,2.15284246 12.7310192,1.36831205 11.7158463,0.825849709 C10.7006734,0.283387365 9.56741104,-0.000260412519 8.41645552,1.79395201e-07 Z",
    id: "Path-22548",
    fill: "#0A186E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35457025,6.07365558 L1.43509719,3.72054364 M3.35457025,6.07365558 L1.47315229,8.19305374",
    id: "Vector",
    stroke: "#0A186E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(2.3948, 5.9568) rotate(-257) translate(-2.3948, -5.9568)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0A186E",
    transform: "translate(4.1848, 11.5479) rotate(42) translate(-4.1848, -11.5479)",
    x: 3.18480313,
    y: 10.7729108,
    width: 2,
    height: 1.55,
    rx: 0.775
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.6165, 2.68)",
    fill: "#0A186E"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(0.61, 2.5) rotate(90) translate(-0.61, -2.5)",
    x: -1.89,
    y: 1.95,
    width: 5,
    height: 1.1,
    rx: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(1.9876, 5.3034) rotate(32) translate(-1.9876, -5.3034)",
    x: -0.0124482124,
    y: 4.75335438,
    width: 4,
    height: 1.1,
    rx: 0.55
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHistory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/History.a784837ea65e03b64570f30695863cbe.svg";